import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

// Per-user "is currently producing voice activity" signals, fed from the
// room-level `AudioActivity` event in OdinService. Sibling of
// ActiveSpeakerTrackerService: same source, unlatched semantics — flips with
// each raw event for fast UI indicators (avatar ring, tile active class).
// Consumers read via `audioActiveFor(userId)` and stay subscribed across
// store-emit churn; no per-component peer.addEventListener attachments.
@Injectable({ providedIn: 'root' })
export class AudioActivityService {
  private _signals = new Map<string, WritableSignal<boolean>>();

  audioActiveFor(userId: string): Signal<boolean> {
    return this._ensure(userId);
  }

  set(userId: string, isActive: boolean) {
    this._ensure(userId).set(isActive);
  }

  seedForPeer(userId: string, isActive: boolean) {
    this._ensure(userId).set(isActive);
  }

  clear(userId: string) {
    const s = this._signals.get(userId);
    if (s) s.set(false);
  }

  resetAll() {
    for (const s of this._signals.values()) s.set(false);
  }

  private _ensure(userId: string): WritableSignal<boolean> {
    let s = this._signals.get(userId);
    if (!s) {
      s = signal(false);
      this._signals.set(userId, s);
    }
    return s;
  }
}
